import { MESSAGING } from 'core/datasets/action';
import { messagingActions } from 'messaging/redux/messagingActions';
import { Message } from 'messaging/types/messages';
import { SelectChannelAction } from 'messaging/types/redux/messagingActions';
import { fork, put, call } from 'redux-saga/effects';
import { onItemAddedWatcher } from '../../../firebase/saga/workers/onItemAddedWatcher';
import { getFirebaseUser } from './firebaseUtils';
import { unsubscribePreviousChannel } from './unsubscribePreviousChannel';

export function* channelSelectedAndMessagesSubscribed(action: SelectChannelAction): Generator {
    const channelId = action.payload;
    yield call(unsubscribePreviousChannel);

    if (!channelId) {
        return;
    }

    const firebaseUser = yield call(getFirebaseUser);
    yield put(messagingActions.channelViewed(channelId));
    yield fork(
        onItemAddedWatcher,
        `channels/${channelId}/messages`,
        MESSAGING.ADD_CHANNEL_MESSAGE,
        (data): Message | null => {
            const value = data.val();

            return {
                id: data.key ?? '',
                text: value.message,
                authorId: value.user,
                timestamp: value.timestamp,
                channelId,
                isCurrentUser: value.user === (firebaseUser as { uid: string }).uid,
                files: value.files,
                assistant: value.assistant,
                error: value.error,
                callback: value.callback,
            };
        },
        true,
        25,
    );
}
